var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 17.3601C12.9385 17.3601 12.0752 16.4967 12.0752 15.4351V12.5534C12.0752 11.4918 12.9385 10.6284 14.0002 10.6284C15.0619 10.6284 15.9252 11.4918 15.9252 12.5534V15.4351C15.9252 16.4967 15.0619 17.3601 14.0002 17.3601Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8103 15.7149C19.577 18.7249 17.057 21.0816 14.0003 21.0816C10.7803 21.0816 8.16699 18.4682 8.16699 15.2482V12.7515C8.16699 9.53155 10.7803 6.91821 14.0003 6.91821C17.022 6.91821 19.507 9.21653 19.7987 12.1565",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.33325H19.8333C23.3333 2.33325 25.6667 4.66659 25.6667 8.16659V10.4999",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 10.4999V8.16659C2.33301 4.66659 4.66634 2.33325 8.16634 2.33325H10.4997",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25.6667H19.8333C23.3333 25.6667 25.6667 23.3333 25.6667 19.8333V17.5",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 17.5V19.8333C2.33301 23.3333 4.66634 25.6667 8.16634 25.6667H10.4997",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerScan);
export default __webpack_public_path__ + "static/media/finger-scan.5b0fa1578ff0bfa3d4b2c6d8f2e6bdd0.svg";
export { ForwardRef as ReactComponent };